import { createSelector } from 'reselect';

import { appState } from './utils';
import { isDocumentUploadWidget } from './widget';
import { getDocuments as getMerchantDocuments } from './merchant/common';
import { AttachmentTypeEnum } from '@/constants/documents';

const documentUploadState = createSelector(appState, (state: GlobalState) => state.documentUpload);

export const getStakeholdersWithUploadedDocuments = createSelector(
  documentUploadState,
  (state: DocumentUpload) => {
    return state?.stakeholders || [];
  },
);

export const getDocuments = createSelector(
  getStakeholdersWithUploadedDocuments,
  getMerchantDocuments,
  isDocumentUploadWidget,
  (stakeholders, merchantDocuments, isDocumentUploadWidget) => {
    if (isDocumentUploadWidget) {
      return stakeholders.reduce<Array<StakeholderDocument>>(
        (total, { documents = [] }) => [...total, ...documents],
        [],
      );
    }
    return merchantDocuments as Array<StakeholderDocument>;
  },
);

export const getDocumentsOfType = (
  type: AttachmentTypeEnum,
): ((value: GlobalState) => StakeholderDocument[]) =>
  createSelector(getDocuments, (documents = []) => documents.filter(doc => doc.type === type));

export const shouldCollectDocuments = createSelector(
  getStakeholdersWithUploadedDocuments,
  stakeholders =>
    stakeholders.some(({ documentRequirements = [] }) =>
      documentRequirements.some(d => d.required),
    ),
);

export const hasLoadedDocumentTokenOnce = createSelector(
  documentUploadState,
  state => state?.loadedOnce,
);
